import { TableRow, TableCell } from '@mui/material';
import { AnyPlan } from '../../../types';
import { hasAnyDifference, isDifferentFromBase } from './helpers';

type OfflineBudgetHeaderProps = {
  plans: AnyPlan[];
  firstColWidth: number;
  formatBudget: (v?: number, currency?: string) => string;
  offlineTotals: { sum: number; currency?: string }[];
  offlineTotalsSums: number[];
  showOnlyDifferences: boolean;
};

export default function OfflineBudgetHeader({
  plans,
  firstColWidth,
  formatBudget,
  offlineTotals,
  offlineTotalsSums,
  showOnlyDifferences,
}: OfflineBudgetHeaderProps) {
  const headerHasDiff = hasAnyDifference<number>(offlineTotalsSums);

  if (showOnlyDifferences && !headerHasDiff) return null;

  return (
    <TableRow
      sx={{
        bgcolor: '#EDEDED',
        height: '56px',
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#C7D8F9',
      }}
    >
      <TableCell
        sx={{
          width: firstColWidth,
          fontWeight: 700,
          fontSize: '16px',
          textTransform: 'uppercase',
          color: '#525F81',
          borderRight: '1px solid',
          borderLeft: '1px solid',
          borderColor: '#C7D8F9',
        }}
      >
        OFFLINE BUDGET
      </TableCell>
      {plans.map((plan, index) => {
        const { sum, currency } = offlineTotals[index];
        const diff = isDifferentFromBase<number>(offlineTotalsSums, index);

        return (
          <TableCell
            key={`offline-total-${plan.id}`}
            sx={{
              borderLeft: '1px solid',
              borderColor: '#C7D8F9',
              textAlign: 'center',
              fontWeight: 700,
              fontSize: '16px',
              color: diff ? 'error.main' : '#525F81',
            }}
          >
            {sum > 0 ? formatBudget(sum, currency || 'PLN') : 'N/A'}
          </TableCell>
        );
      })}
    </TableRow>
  );
}
